import { useMemo } from 'react'
import { StockType } from 'types/stock'

const useHasSamePickupableTime = (stocks: StockType[]): boolean => {
  return useMemo(() => {
    // 削除された対象は除外する
    const targets = stocks.filter((stock) => !stock.is_deleted)
    const stocksSet = new Set()
    targets.map((stock) => stocksSet.add(stock.pickupable_time))
    return targets.length !== stocksSet.size
  }, [stocks])
}

export default useHasSamePickupableTime
